export default {
    bind(el) {
        el.setAttribute('tabindex', '0')
        el.addEventListener('keydown', e => {
            if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
                e.preventDefault()
                const range = document.createRange()
                range.selectNodeContents(el)
                const selection = window.getSelection()
                selection.removeAllRanges()
                selection.addRange(range)
            }
        })
    },
    unbind(el) {
        el.removeEventListener('keydown')
    }
}
